import { FC, useMemo } from 'react'
import { Carousel } from 'react-bootstrap'

import useDocumentContentObjectUrl from './use-document-content-object-url'

import { isImage } from '../../../util/file'
import { IDocument } from '../../../interfaces'
import { FetchDocumentContent } from './document-upload-context-types'

// @ts-ignore
import s from './documents-carousel.module.scss'

type DocumentsCarouselProps = {
  documents: IDocument[]
  setCurrentDocument: (document: IDocument) => void
  currentDocument: IDocument
  fetchDocumentContent: FetchDocumentContent
}

type DocumentImageProps = {
  document: IDocument
  fetchDocumentContent: FetchDocumentContent
}

const DocumentImage: FC<DocumentImageProps> = ({ document, fetchDocumentContent }) => {
  const { objectUrl, hasError } = useDocumentContentObjectUrl(document, fetchDocumentContent)

  if (hasError) {
    return <span className="default-inner-content">Preview could not be loaded for this file.</span>
  }

  if (!objectUrl) {
    return <span className="default-inner-content">Loading preview...</span>
  }

  return <img className="slider-image" src={objectUrl} alt={document.name} />
}

const DocumentsCarousel: FC<DocumentsCarouselProps> = props => {
  const { documents, currentDocument, setCurrentDocument, fetchDocumentContent } = props

  const slideHandler = (carouselIndex: number) => setCurrentDocument(documents[carouselIndex])

  const activeCarouselIndex = useMemo(
    () => documents.findIndex(document => document.id === currentDocument.id),
    [documents, currentDocument.id],
  )

  return (
    <Carousel
      keyboard
      onSelect={slideHandler}
      activeIndex={activeCarouselIndex > -1 ? activeCarouselIndex : 0}
      wrap={false}
      interval={null}
      className="h-100"
    >
      {documents.map(document => (
        <Carousel.Item key={document.id} className={s['carousel-item']}>
          <div className={s['carousel-inner']}>
            {isImage(document.name) ? (
              document.id === currentDocument.id && (
                <DocumentImage document={document} fetchDocumentContent={fetchDocumentContent} />
              )
            ) : (
              <span className="default-inner-content">Preview is not available for this file.</span>
            )}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default DocumentsCarousel
